import React, { Component } from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import Pluralize from "pluralize"

import "./CustomerDetails.scss"


export class CustomerDetails extends Component {
  render() {
    let { customer, subscriptions, user } = this.props

    if (!user || !customer) {
      return <></>
    }

    let trialDaysLeft = 0
    if (customer.trialEnd) {
      let trialEnd = new Date(customer.trialEnd)
      let trialMsLeft = trialEnd - new Date()
      trialDaysLeft = Math.floor(trialMsLeft  / (1000 * 3600 * 24)) + 1
    }
    let hasArchie = subscriptions.includes("archie")
    if (hasArchie) {
      return (
        <div>
          <p>{user.email}</p>
          <p>You are subscribed to Archie</p>
        </div>
      )
    } else {
      return (
        <div className="customer-details">
          <p>{user.email}</p>
          <p>{trialDaysLeft > 0 ? `${Pluralize("day", trialDaysLeft, true)} remaining on trial` : "Trial Expired"}</p>
        </div>
      )
    }
  }
}

CustomerDetails.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
  }),
  customer: PropTypes.shape({
    trialEnd: PropTypes.string,
  }),
  subscriptions: PropTypes.arrayOf(PropTypes.string)
}


const mapStateToProps = state => ({
  customer: state.customer,
  subscriptions: state.subscriptions,
  user: state.user,
})


export default connect(mapStateToProps)(CustomerDetails)
